import { useStaticQuery, graphql } from "gatsby"

export const useCompanyData = () => {
    const company = useStaticQuery(
        graphql`
            query CompanyData {
                strapiCompany(strapiId: { eq: "61e62d34c5bb30b77028cd61" }) {
                    id
                    name
                    shortname
                    tel
                    whatsapp
                    email
                    address
                    addressCountry
                    postalCode
                    website
                    SocialMedia {
                    social_media_name
                    Link
                    icon {
                        extension
                        publicURL
                    }
                    }
                    metadata {
                        title
                        description
                    }
                    company_logo {
                        publicURL
                    }
                    company_logo_icon {
                        publicURL
                    }
                    teams {
                        name
                        slug
                    }
                }
            }
        `
    )
    return company.strapiCompany
}

/********
 * DUMMY Data company
 */

//  export const useCompanyData = () => {
//     return {
//         address:
//             "583 Orchard Road #15-04\nForum The Shopping Mall\nSingapore 238884",
//         company_logo: {
//             publicURL:
//                 "/static/80dd516603a06244501c3dc6d013530f/31584db178e1920525d1855a446241a3.svg",
//         },
//         email: "inquiry@dynamics.com.sg",
//         id: "Company_6093505940bc8f40c4f1d8d6",
//         name: "Dynamics Therapy Centre for Kids",
//         tel: "+65 6100 9235",
//         whatsapp: "+65 9380 6207",
//     }
// }
